import View from './EnrollmentAndTuition';
import { PeriodsLoader } from './parts/Loaders/PeriodsLoader';
import { StudyPlanOffersLoader } from './parts/Loaders/StudyPlanOffersLoader';

export default function EnrollmentAndTuition() {
  return (
    <PeriodsLoader>
      <StudyPlanOffersLoader>
        <View />
      </StudyPlanOffersLoader>
    </PeriodsLoader>
  );
}
